<template lang="pug">
  v-app
    side-menu
    top-bar(style="position:fixed" :title="title")
        template(slot="logOutSlot")
            CriticalStockBox(
                :infoSession="infoSession" 
                colorIconBtn="success11"
                timeInterval='100000' 
                )
            SessionBox(
            :infoSession="infoSession" 
            colorIconBtn="success" 
            )
                template(slot="actions")
                    v-spacer
                    v-tooltip(bottom)
                        v-btn( icon='' slot="activator" v-on:click="logout()")
                            v-icon exit_to_app
                        span Cerrar
    v-content(class="main-content" ref="main-content")
      router-view(:key="$route.fullPath")
</template>


<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import SideMenu from './SideMenu.vue'
import TopBar from './TopBar.vue'
import SessionBox from '../../reusable_components/SessionBox/SessionBox'
import CriticalStockBox from '../../reusable_components/CriticalStockBox/CriticalStockBox'
//import WhDetailProductCriticalNotifMdl from '@/models/Warehouse/WhDetailProductCriticalNotif'

export default {
    name: 'dashboard-menu',
    props: {
        /**
         * @description
         */
        title: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            infoSession:{
                title:"",
                subtitle:[
                'Sucursal:  ',
                ]
            },
            model:"hola",
        }
    },
    computed: {
        ...mapState('sidebar', {
          drawer: 'drawer',
        }),
        ...mapState('AuthModule', {
            user: 'user',
        }),
    },
    methods: {
        ...mapActions('sidebar', {
            toggleSidebar: 'toggleSidebar'
        }),
        ...mapActions('SessionModule', {
            resetState: 'resetState'
        }),
        hideBar: function(){
          if(this.drawer) this.toggleSidebar()
        },
        setInfoSessionBox: function(){
            this.infoSession={
                title: this.user.hr_employee.name_case,
                subtitle:[
                    `Sucursal: ${this.user.hr_employee.g_branch_office.name}`,
                ]
            }
        },
        // setModelBox: function(){
        //     this.model = WhDetailProductCriticalNotifMdl
        // },
        /*
         */
        logout: function() {
            console.log('logout')
            event.preventDefault()
            this.authLogout()
                .then(() => {
                    this.$router.push('/login')
                })
                .catch(err => {
                    console.log(err)
                    this.$router.push('/login')
                })
        },
        ...mapActions('AuthModule', {
            authLogout: 'logoutRequestAction',
        })

    },
    components: {
        SideMenu,
        TopBar,
        SessionBox,
        CriticalStockBox
    },
    created: async function() {
        await this.resetState()
    },
    mounted: function() {
        this.$refs['main-content'].$el.addEventListener('click', this.hideBar)
        this.setInfoSessionBox()
        this.setModelBox()
    },
    beforeDestroy: function(){
        this.$refs['main-content'].$el.removeEventListener('click', this.hideBar)
    },
    watch: {
        $route () {
            this.$store.dispatch("MenuesModule/setAppToolbarItems", { items: [] })
        }
    }
}
</script>

<style lang="scss" scoped>
.main-content {
    overflow: auto;
}
</style>